import React from 'react'
import Layout from './pages/Layout'
import { BrowserRouter } from 'react-router-dom'
import { Route, Switch } from 'react-router'
import PrivateRoute from '../common/PrivateRoute'
import LogoutPage from '../common/LogoutPage'
import AuthPage from '../common/AuthPage'
import LogoutSuccessPage from './pages/LogoutSuccessPage'
import ErrorPage from '../common/ErrorPage'
import PrivateApp from './PrivateApp'
import CguPage from "./pages/cgu/CguPage";
import moment from 'moment'
import 'moment/locale/fr'
moment.locale('fr')


function App() {
  return (
    <BrowserRouter basename={ '/beneficiary' }>
      <Layout>
        <Switch>
          <Route path="/auth" component={ AuthPage } />
          <Route path="/logout" component={ LogoutPage } />
          <Route path="/logout-success" component={ LogoutSuccessPage } />
          <Route path="/error/:status" component={ ErrorPage } />
          <Route path="/cgu" component={ CguPage } />
          <PrivateRoute path="/" component={ PrivateApp }/>
        </Switch>
      </Layout>
    </BrowserRouter>
  )
}

export default App
